// LiveStreamGiftSlider.js
import { connect } from 'react-redux';

import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import fetchRemoteConfig from '../action/fetchRemoteConfig.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import LiveStreamGiftSlider from '../component/LiveStreamGiftSlider.jsx';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { GIFT_CATEGORIES_LIVESTREAM } from '../RemoteConfigKeys.js';

function mapStateToProps(state, { userId }) {
  const privateUserConfigId = `private-enc-user=${userId}`;
  return {
    giftSendingStatus: getOperationData(
      state,
      ['liveStream', 'gift'],
      'giftSendingStatus'
    ),
    privateUserConfigId,
    categories: getRemoteConfigData(
      state,
      GIFT_CATEGORIES_LIVESTREAM,
      privateUserConfigId
    ),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setLiveStreamPanel: ({ isGiftPanelSwiping }) =>
      dispatch(setLiveStreamPanel({ isGiftPanelSwiping })),
    cleanGiftSendingStatus: () =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['liveStream', 'gift'],
          data: {
            giftSendingStatus: null,
          },
        },
      }),
    fetchRemoteConfig: ({ configId }) =>
      dispatch(fetchRemoteConfig({ configId })),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamGiftSlider);
